import BadgeStatus from '../../../../atoms/BadgeStatus';
import { ACTIVATION_LABEL, ActivationStatus } from '../collectionModel';

interface ActivationBadgeProps {
    status: ActivationStatus;
    reason?: string | null;
}

const ActivationBadge = ({ status, reason }: ActivationBadgeProps) => (
    <span title={reason ?? undefined}>
        <BadgeStatus color={status === 'ACTIVE' ? 'green' : 'gray'} text={ACTIVATION_LABEL[status]} />
    </span>
);

export default ActivationBadge;
